<template>
  <router-view />
</template>

<script>

import AuthRepository from "../src/repositories/AuthRepository";

// urlB64ToUint8Array is a magic function that will encode the base64 public key
// to Array buffer which is needed by the subscription option


export default {
    name: 'App',
    components: {

    },
    data: () => ({

    }),
    created () {
    },
};
</script>

<style>
@import "styles.css";

@font-face {
  font-family: "ChampagneAndLimousines";
  src: local("ChampagneAndLimousines"),   url(./fonts/ChampagneAndLimousines.ttf);
  /*font-family: 'Montserrat';
  src:local('Montserrat'), url('./fonts/Montserrat-VariableFont_wght.ttf') format('truetype');*/
}

</style>
